<template>
  <div class="message-widget-deprecated">
    <div class="tab" @click="open = !open">
      <h3 class="header">MESSAGES</h3>
      <span class="unavailable-badge">Unavailable</span>
    </div>
    <div class="panel" v-if="open">
      <div class="notice">
        <p class="notice__title">Chat is no longer available</p>
        <p class="notice__body">
          The messaging feature has been discontinued. For support, please visit
          our help center.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      open: false,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
@import "@/assets/style/_variables.scss";

.message-widget-deprecated {
  position: fixed;
  bottom: 0;
  right: 34rem;
  z-index: 9;
  width: 26rem;

  @include tablet-down {
    right: 0;
    width: 100%;
  }

  .tab {
    background-color: #18181b;
    cursor: pointer;
    height: 5.5rem;
    border-radius: 8px 8px 0 0;
    display: flex;
    align-items: center;
    padding: 0 1.5rem;
    border: 1px solid #3d4049;
    border-bottom: none;

    .header {
      font-family: $font-display;
      color: #fff;
      font-weight: 600;
      font-size: 1.8rem;
    }

    .unavailable-badge {
      margin-left: 1rem;
      font-size: 1.1rem;
      font-weight: 600;
      color: #f14950;
      background: rgba(241, 73, 80, 0.15);
      border-radius: 4px;
      padding: 0.2rem 0.6rem;
      text-transform: uppercase;
      letter-spacing: 0.04em;
    }
  }

  .panel {
    background-color: #fff;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    padding: 2.4rem;

    .notice {
      &__title {
        font-weight: 600;
        font-size: 1.6rem;
        color: #1a1a2e;
        margin-bottom: 0.8rem;
      }

      &__body {
        font-size: 1.4rem;
        color: #6f7c8b;
        line-height: 1.5;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/message_widget/MessageWidget.vue